import { render } from "./ReportsPage.vue?vue&type=template&id=22e3239c"
import script from "./ReportsPage.vue?vue&type=script&lang=js"
export * from "./ReportsPage.vue?vue&type=script&lang=js"

import "./ReportsPage.vue?vue&type=style&index=0&id=22e3239c&lang=css"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__